/**
 * Общие хелперы парсинга для *-store файлов (чтение строк SQLite, где часть
 * полей хранится как JSON-текст). До 2026-06-10 каждый store держал свою
 * копию parseJson — теперь одно место правды.
 *
 * Внимание: numberArray НЕ выносится сюда специально — у finance-store и
 * metric-store разная семантика (finance паддит массив до DAILY_DAYS нулями,
 * metric просто мапит). Унификация сломала бы графики.
 */

/** JSON.parse с fallback: null/пустая строка/битый JSON/null-результат → fallback. */
export function parseJson<T>(raw: string | null | undefined, fallback: T): T {
  if (!raw) return fallback;
  try {
    const parsed = JSON.parse(raw) as T;
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

/** Число или 0: защита от NaN/Infinity/нечисловых значений из БД. */
export function finiteNumber(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

/** Округление денег до копеек поверх finiteNumber. */
export function roundMoney(value: unknown): number {
  return Math.round(finiteNumber(value) * 100) / 100;
}
